import script from "./AddServiceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddServiceModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddServiceModal.vue?vue&type=style&index=0&id=1f403b41&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f403b41"]])

export default __exports__